import {z} from 'zod'
import {EnvironmentName} from './EnvironmentName.js'
import {EncryptionKey} from '../encryption/index.js'

export const EnvironmentVariables = z.object({
  PROJECT_ID: z.string().default('time-track'),
  PROJECT_NAME: z.string().default('devtime'),
  ENVIRONMENT_NAME: EnvironmentName,
  COMMIT_SHA: z.string().default('unknown'),
  ENCRYPTION_KEY: EncryptionKey,
  AWS_ACCESS_KEY_ID: z.string(),
  AWS_REGION: z.string(),
  AWS_SECRET_ACCESS_KEY: z.string(),
  SENTRY_USER_AUTH_TOKEN: z.string(),
  AUTH0_DOMAIN: z.string(),
  AUTH0_CLIENT_ID: z.string(),
  AUTH0_CLIENT_SECRET: z.string(),
  STRIPE_API_KEY: z.string(),
  CYPRESS_BASE_URL: z.string().nullish(),
  PULUMI_CONFIG_PASSPHRASE: z.string(),
  MONGODB_ATLAS_PUBLIC_KEY: z.string(),
  MONGODB_ATLAS_PRIVATE_KEY: z.string(),
  MONGODB_ATLAS_ORGANIZATION_ID: z.string(),
})
export type EnvironmentVariables = z.infer<typeof EnvironmentVariables>
